// Local draft persistence for long-form editors (Articles, Newsletter issues).
//
// Why this exists: the dashboard sits behind a 24h JWT + 30-min idle timeout.
// If a session expires mid-compose, the axios interceptor redirects to /login,
// and whatever the author typed into the editor is lost. We auto-save a
// working copy to localStorage so nothing is ever dropped on the floor.

const PREFIX = "elle_draft:";

export function draftKey(scope, id = "new") {
  return `${PREFIX}${scope}:${id || "new"}`;
}

export function saveDraft(key, data) {
  try {
    localStorage.setItem(key, JSON.stringify({
      data,
      saved_at: Date.now(),
    }));
  } catch (_e) { /* quota — ignore */ }
}

export function loadDraft(key) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && parsed.data ? parsed : null;
  } catch { return null; }
}

export function clearDraft(key) {
  try { localStorage.removeItem(key); } catch {}
}

export function formatDraftAge(ts) {
  if (!ts) return "";
  const secs = Math.max(1, Math.round((Date.now() - ts) / 1000));
  if (secs < 60) return `${secs}s ago`;
  const mins = Math.round(secs / 60);
  if (mins < 60) return `${mins} min${mins === 1 ? "" : "s"} ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs} hour${hrs === 1 ? "" : "s"} ago`;
  const days = Math.round(hrs / 24);
  return `${days} day${days === 1 ? "" : "s"} ago`;
}
